<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<p class="contentsHead">Contents</p>
<p class="contentsEntry"><a href="#/TriumphandDefeat_prefaceandacknowledgments#prefaceandacknowledgments">Preface and Acknowledgments</a></p>
<p class="contentsEntry"><a href="#/TriumphandDefeat_foreword#foreword">Foreword</a></p>
<p class="contentsEntry"><a href="#/TriumphandDefeat_ch1#chapter1">Chapter 1: Beyond the Rubicon: The Union Army Secures Its Beachhead on Mississippi Soil</a></p>
<p class="contentsEntry"><a href="#/TriumphandDefeat_ch2#chapter2">Chapter 2: Blitzkrieg: Grant Style</a></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch3#chapter3" title="Link target outside of Sample">Chapter 3: The National Colors Are Restored O’er the Capitol</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch4#chapter4" title="Link target outside of Sample">Chapter 4: John A. McClernand: Fighting Politician</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch5#chapter5" title="Link target outside of Sample">Chapter 5: Companion to the Fishes: The Saga of the Gunboat Cincinnati</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch6#chapter6" title="Link target outside of Sample">Chapter 6: The Lords of Vicksburg</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch7#chapter7" title="Link target outside of Sample">Chapter 7: “I Am Too Late:” Joseph E. Johnston and the Army of Relief</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch8#chapter8" title="Link target outside of Sample">Chapter 8: “No Longer A Point of Danger:” The Siege of Jackson</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch9#chapter9" title="Link target outside of Sample">Chapter 9: Crucial to the Outcome: Vicksburg and the Trans-Mississippi Supply Line</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_ch10#chapter10" title="Link target outside of Sample">Chapter 10: Stephen D. Lee and the Making of an American Shrine</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_epilogue#epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="contentsEntry"><span href="#/TriumphandDefeat_bibliography#bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="paraCenter2">Maps and illustrations have been distributed throughout the text for the convenience of the reader.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TriumphandDefeat_toc.vue?081c2a8c